import { RolesAPI } from "../apis";
import auth from '../common/Auth';

export const getRoles = ( id ) => {
        
    const token = auth.getAccessToken();

    const rolesAPI = new RolesAPI(token);
    
    return rolesAPI.getAll();
    
}
